<div class="gw-w-full gw-mx-auto">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="gw-space-y-6">
    <div class="gw-space-y-4 gw-p-x-large">
      <p class="gw-text-text-primary gw-text-base">
        {{
          'features.settings.parameters.' + setting.key + '.description'
            | translate
        }}
      </p>
      <gatewee-multi-select
        formControlName="whitelist"
        [control]="control"
        [items]="items"
        [loading]="loadingRecipients"
        [label]="'features.settings.parameters.' + setting.key + '.label'"
        [placeholder]="
          'features.settings.parameters.' + setting.key + '.placeholder'
            | translate
        "
      ></gatewee-multi-select>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
